import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';
import { IOffer } from '@proximus/common-business-logic';

export const GET_COPPER_OUT_PHASING_OFFER = 'GET_COPPER_OUT_PHASING_OFFER';
export const GET_COPPER_OUT_PHASING_OFFER_SUCCESS =
  'GET_COPPER_OUT_PHASING_OFFER_SUCCESS';
export const GET_COPPER_OUT_PHASING_OFFER_FAILED =
  'GET_COPPER_OUT_PHASING_OFFER_FAILED';

export class GetCopperOutPhasingOffer implements Action {
  type = GET_COPPER_OUT_PHASING_OFFER;

  constructor(public payload?: any) {}
}

export class GetCopperOutPhasingOfferSuccess implements Action {
  type = GET_COPPER_OUT_PHASING_OFFER_SUCCESS;

  constructor(public payload: IOffer) {}
}

export class GetCopperOutPhasingOfferFailed implements Action {
  type = GET_COPPER_OUT_PHASING_OFFER_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetCopperOutPhasingOffer
  | GetCopperOutPhasingOfferSuccess
  | GetCopperOutPhasingOfferFailed;
